import React, { Component } from 'react'
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons'
import { Modal, Table, Button } from 'hljd'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import style from './style.module.less'
@observer
class SortModal extends Component {
  render() {
    const { store } = this.props
    const sortList = toJS(store.sortList)
    const { sortModalVisible, setStoreData } = store
    const columns = [
      {
        title: '排名',
        dataIndex: 'index',
        key: 'index',
        render: (text, record, index) => {
          return <span>{index + 1}</span>
        }
      },
      {
        title: '类目',
        dataIndex: ['property', 'name'],
        key: 'name'
      },
      {
        title: '排序',
        dataIndex: 'sort',
        key: 'sort',
        render: (text, record, index) => {
          return (
            <div className="sort-btn-wrap">
              <ArrowUpOutlined
                className={index === 0 ? 'disable' : ''}
                onClick={() => store.orderFn(record.id, index, 'up')}
              />
              <ArrowDownOutlined
                className={index === sortList.length - 1 ? 'disable' : ''}
                onClick={() => store.orderFn(record.id, index, 'down')}
              />
            </div>
          )
        }
      }
    ]
    return (
      <Modal
        title="调整展示顺序"
        visible={sortModalVisible}
        onOk={() => setStoreData('sortModalVisible', false)}
        onCancel={() => setStoreData('sortModalVisible', false)}
        okText="完成"
        width={400}
        wrapClassName={style.sortModalWrap}
        footer={[
          <Button
            key="ok"
            type="primary"
            onClick={() => setStoreData('sortModalVisible', false)}
          >
            完成
          </Button>
        ]}
      >
        <p>
          调整产品内品类展示排序，前面的品类将会优先展示在用户端APP和商家后台
        </p>
        <div className="sort-table-wrap">
          <Table
            dataSource={sortList}
            columns={columns}
            rowKey={record => record.id}
            pagination={false}
          />
        </div>
      </Modal>
    )
  }
}

export default SortModal
